import React from 'react';

export type SortOption = 'name' | 'revenue' | 'customers' | 'performance';

interface SortControlsProps {
  value: SortOption;
  onChange: (value: SortOption) => void;
}

const SortControls: React.FC<SortControlsProps> = ({ value, onChange }) => {
  // Get the label for the current sort option
  const getSortLabel = (option: SortOption): string => {
    const labels: Record<SortOption, string> = {
      name: 'نام شعبه',
      revenue: 'فروش',
      customers: 'تعداد مشتریان',
      performance: 'عملکرد'
    };
    return labels[option];
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-6" role="region" aria-label="کنترل‌های مرتب‌سازی">
      <label
        htmlFor="branch-sort-select"
        className="text-sm md:text-base font-medium text-text-primary"
      >
        مرتب‌سازی بر اساس:
      </label>
      <select
        id="branch-sort-select"
        value={value}
        onChange={(e) => onChange(e.target.value as SortOption)}
        className="w-full sm:w-auto px-4 py-3 min-h-[44px] bg-bg-secondary border border-border-default rounded-lg text-sm md:text-base text-text-primary focus:outline-none focus:border-border-accent focus:ring-2 focus:ring-primary-600 focus:ring-opacity-20 transition-all duration-base hover:bg-bg-tertiary cursor-pointer touch-manipulation"
        aria-label={`انتخاب نوع مرتب‌سازی شعب. مرتب‌سازی فعلی: ${getSortLabel(value)}`}
        aria-describedby="sort-description"
      >
        <option value="name">نام شعبه</option>
        <option value="revenue">فروش</option>
        <option value="customers">تعداد مشتریان</option>
        <option value="performance">عملکرد</option>
      </select>
      <span id="sort-description" className="sr-only">
        انتخاب معیار مرتب‌سازی شعب در لیست
      </span>
    </div>
  );
};

export default SortControls;
